import { useEffect, useState } from 'react';

// 顶部状态栏高度
function useStatusBarHeight() {
  const [height, setHeight] = useState(0.24);
  useEffect(() => {
    window?.nativeBridge &&
      window.nativeBridge.callNativeFunction('getStatusBarHeight', null, (response) => {
        setHeight(parseFloat(response) / 100);
      });
  }, []);
  return height;
}

export default useStatusBarHeight;

